export default __webpack_public_path__ + "static/media/ws.57f8ef6d.svg";